module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AllEmployeeView.jsx"));
	}, "AllPost");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AllPost!./src/pages/bundle-org-mgmt/AllEmployee/AllEmployeeView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=AllPost!./src/pages/bundle-org-mgmt/AllEmployee/AllEmployeeView.jsx
// module chunks = 43